<template>
  <div class="overflow-x-auto bg-surface-default-mid py-16 scrollbar-none">
    <PlpContainer class="w-auto" :is-wide>
      <ul class="flex items-start gap-8 md:gap-16">
        <li
          v-for="criterion in criteria"
          :key="criterion.criterion"
          class="w-[288px] h-[320px] shrink-0"
        >
          <FinderSizeCard
            v-if="criterion.criterion === 'size' && sizeCriterion"
            v-model:selected-option-ids="selectedSizeOptionIds"
            :criterion="sizeCriterion"
            @select-range="handleSelectSizeRange"
          />
          <FinderCard v-else :title="criterion.title" />
        </li>
      </ul>
    </PlpContainer>
  </div>
</template>

<script lang="ts" setup>
import { type ShallowReactive, ref } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { findCriterion, useFinder } from '../../composables/useFinder/useFinder'
import { getMacbookFinderConfig } from '../../composables/useFinder/useFinder.config.macbook'
import { useSizeCard } from '../../composables/useFinder/useSizeCard'
import PlpContainer from '../PlpContainer/PlpContainer.vue'

import { getFinderCriteria } from './Finder.utils'
import FinderCard from './components/FinderCard/FinderCard.vue'
import FinderSizeCard from './components/FinderSizeCard/FinderSizeCard.vue'

const props = defineProps<{
  filtersInput?: Record<string, string[]>
}>()

const i18n = useI18n()

const criteria = getFinderCriteria(i18n)

const config = getMacbookFinderConfig(i18n)
const sizeCriterion = findCriterion(config, 'size')

const localPriceInput = ref<[number, number] | undefined>(undefined)
const finder = props.filtersInput
  ? useFinder(
      config,
      props.filtersInput as ShallowReactive<Record<string, string[]>>,
      localPriceInput,
    )
  : null

const { selectedSizeOptionIds, handleSelectSizeRange } = useSizeCard(
  finder,
  sizeCriterion,
)

const experiments = useExperiments()
const isWide =
  experiments['experiment.plpWideContainer'] === 'withWideContainer'
</script>
